export default () => ({

})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/select-dates/resources/data.js